/**
 * home static message
 */
if (!customElements.get("home-static-message")) {
  class HomeStaticMessage extends HTMLElement {
    constructor() {
      super();
      this.staticMessage = null;
    }

    connectedCallback() {
      // Wait for Splide to be available
      const initSplide = () => {
        if (typeof Splide !== 'undefined') {
          const staticMessageElement = document.getElementById("static_message");
          if (staticMessageElement) {
            this.staticMessage = new Splide("#static_message", {
              type: "slide",
              perMove: 1,
              perPage: 4,
              lazyLoad: "sequential",
              arrows: false,
              pagination: false,
              breakpoints: {
                768: {
                  perPage: 1,
                },
                1200: {
                  perPage: 3,
                },
              },
            });
            this.staticMessage.mount();
          }
        } else {
          // Retry after a short delay if Splide isn't loaded yet
          setTimeout(initSplide, 50);
        }
      };

      // Start initialization
      if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', initSplide);
      } else {
        initSplide();
      }
    }
  }

  if (window.location.pathname == "/") {
    customElements.define("home-static-message", HomeStaticMessage);

    // Wait for DOM to be ready before creating the element
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => {
        const homeStaticMessageElement = document.createElement("home-static-message");
        document.body.appendChild(homeStaticMessageElement);
      });
    } else {
      const homeStaticMessageElement = document.createElement("home-static-message");
      document.body.appendChild(homeStaticMessageElement);
    }
  }
}

/**
 * video banner
 */
class BannerVideo {
  constructor(element) {
    this.element = element;
    this.mobileSrc = element.dataset.mobile_src;
    this.desktopSrc = element.dataset.desktop_src;
    this.init();
  }

  init() {
    this.updateVideoSource();
    window.addEventListener("resize", this.updateVideoSource.bind(this));
  }

  updateVideoSource() {
    const windowWidth = window.innerWidth;
    const videoElement = document.querySelector(".banner-video video");

    if (windowWidth < 1024) {
      videoElement.setAttribute("src", this.mobileSrc);
    } else {
      videoElement.setAttribute("src", this.desktopSrc);
    }
  }
}

document.addEventListener("DOMContentLoaded", function () {
  if (!document.querySelector(".banner-video-container")) return;

  const bannerVideoElement = document.querySelector(".banner-video video");
  if (bannerVideoElement) {
    new BannerVideo(bannerVideoElement);
  }
});

/**
 * Home Banner Slider
 */
const initHomeBannerSliders = () => {
  // Wait for Splide to be available
  if (typeof Splide === 'undefined') {
    setTimeout(initHomeBannerSliders, 50);
    return;
  }

  const bannerSliders = document.querySelectorAll('[id^="home-banner-slider-"]');

  bannerSliders.forEach((slider) => {
    const sectionId = slider.id.replace('home-banner-slider-', '');
    const section = document.querySelector(`[data-section-id="${sectionId}"]`);

    if (!section) return;

    // Only initialize if there are multiple slides
    const slides = slider.querySelectorAll('.splide__slide');
    if (slides.length <= 1) return;

    // Get settings from data attributes or defaults
    const autoplay = section.dataset.autoplay !== 'false' && section.dataset.autoplay !== '';
    const autoplayInterval = parseInt(section.dataset.autoplayInterval) || 5000;
    const showArrows = section.dataset.showArrows !== 'false' && section.dataset.showArrows !== '';
    const showPagination = section.dataset.showPagination !== 'false' && section.dataset.showPagination !== '';

    const splideSettings = {
      type: "loop",
      perMove: 1,
      perPage: 1,
      lazyLoad: "sequential",
      arrows: showArrows,
      pagination: showPagination,
      autoplay: autoplay,
      interval: autoplayInterval,
      gap: 0,
    };

    new Splide(slider, splideSettings).mount();
  });
};

document.addEventListener("DOMContentLoaded", initHomeBannerSliders);

/**
 * section-spotted
 */
(function yotpoPicturesWidget() {
  let spotElement = document.getElementById("section-spotted");
  if (spotElement) {
    let galleryId = "";
    if (window.location.host.indexOf(".co.nz") !== -1) {
      galleryId = "647431f29e40765daca55584";
    } else if (window.location.host.indexOf(".com.au") !== -1) {
      galleryId = "647037b6a23d4d180ca44f32";
    } else {
      galleryId = "6477f3c4b2880f1635a82d7a";
    }

    const observerSpot = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          var div = document.createElement("div");
          div.setAttribute("class", "yotpo yotpo-pictures-widget");
          div.setAttribute("data-gallery-id", galleryId);
          document.querySelectorAll(".yotpo-pictures-widget")[0].after(div);
          yotpo.initWidgets();
          observerSpot.unobserve(entry.target);
        }
      });
    });
    const lazyDiv = document.querySelector(".yotpo-pictures-widget");
    observerSpot.observe(lazyDiv);

    window.addEventListener("load", (event) => {
      var api = new Yotpo.API(yotpo);
      api.refreshWidgets();
    });
  }
})();

